import { Assets, Container, filters, MSAA_QUALITY, Renderer, RenderTexture, Sprite } from "pixi.js";
import { AtlasResource } from "../../ResourceManager/AtlasResource";
import { JSONResource } from "../../ResourceManager/JSONResource";
import { Resourceful, Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { LoadingStage, IWriteOnlyResourceManager, IReadOnlyResourceManager } from "../../ResourceManager/ResourceManager";
import { Settings } from "../../Settings";
import { ISkeletonData, Spine } from "pixi-spine";
import { CreateElement, CreateSpineResources, Scale } from "../../MyHelpers";
import { ISystemContext } from "../../Context/SystemContext";
import { ITimeout } from "../../Context/Timeout";
import { IRandomInterval } from "../../Context/RandomInterval";
import { scale } from "svelte/transition";
import { PlaceHolderMutiPotConfig } from "./FillingPotGeneric";
import { AudioManager, Track } from "../../AudioManager";


export class ShowHitPotElement implements Resourceful {
    readonly potName: string;
    readonly gameResourcesBasePath: string;
    readonly gameName: string;
    readonly systemContext: ISystemContext;
    protected jsonSpine: ISkeletonData = null;
    //protected idleAnimInterval: IRandomInterval = null;
    protected audio : AudioManager;
    protected resid : ResourceIdentifier;
    constructor(potName: string, gameResourcesBasePath: string, gameName: string, systemContext: ISystemContext, audio : AudioManager , resid : ResourceIdentifier) {
        this.potName = potName;
        this.gameResourcesBasePath = gameResourcesBasePath;
        this.gameName = gameName;
        this.systemContext = systemContext;
        this.audio = audio;
        this.resid = resid;     
        //console.log("CreateLayout",potName);        
    }

    public PrepareResources(resourceManager: IWriteOnlyResourceManager) {
        //console.log("CreateLayout-Prepare",this.gameResourcesBasePath)                
        resourceManager.AddGlobal(new JSONResource(`${this.gameResourcesBasePath}FillingPotFeature/${Settings.Screens}Screens/LayoutPotElement/${this.potName}/Show${this.potName}.json`, ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-${this.potName}-ShowHitPot-Json`)));
        resourceManager.AddGlobal(new AtlasResource(`${this.gameResourcesBasePath}FillingPotFeature/${Settings.Screens}Screens/LayoutPotElement/${this.potName}/Show${this.potName}.atlas`, ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-${this.potName}-ShowHitPot-Atlas`)));
        this.audio.AddTrack(new Track(`${this.gameResourcesBasePath}FillingPotFeature/tracks/ShowMultiplier` + Settings.audioFormat, this.resid.ScopedResourceName("ShowMultiplier"), true));        
    }

    public async ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        let jsonResource = resourceManager.Get<JSONResource>(ResourceIdentifier.Global.ScopedResourceName(`${this.gameName}-${this.potName}-ShowHitPot-Json`));
        let resource = await Assets.load(jsonResource.path);
        this.jsonSpine = resource.spineData;
        //await this.ScreenshotLayout();
    }

    protected layoutSpine: Spine = null;
    protected loopWin: boolean = false;
    public CreateElementIntoFillingPotSpine(spineContainer: Spine, placeHolderMutiPotConfig: PlaceHolderMutiPotConfig) {
        //if(this.layoutSpine != null) this.Destroy()
        this.loopWin = placeHolderMutiPotConfig.loopWin;
        this.layoutSpine = new Spine(this.jsonSpine);
        this.layoutSpine.name = this.potName;
        //spineContainer.addChild(this.layoutSpine);

        (spineContainer.children as Container[]).forEach((container) => {
            if (container.name == `${this.potName}PlaceHolder`) {
                let bone = spineContainer.state.data.skeletonData.findBone(`${this.potName}PlaceHolder`);
                let scaleX = this.layoutSpine.scale.x + (1 - bone.parent.scaleX);
                let scaleY = (this.layoutSpine.scale.y) + (1 - bone.parent.scaleY);
                this.layoutSpine.scale.set(scaleX * placeHolderMutiPotConfig.scaleX, (scaleY * -1) * placeHolderMutiPotConfig.scaleY);
                container.addChild(this.layoutSpine);
                bone = null;
                scaleX = null;
                scaleY = null;
                this.layoutSpine.position.set(placeHolderMutiPotConfig.offsetX, placeHolderMutiPotConfig.offsetY);
            }
            container = null
        });
    }

    public Destroy() {        
        this.layoutSpine?.removeFromParent();
        this.layoutSpine = null;
    }

    public SetMultiplier(numberMultiplier : number){   
        if(this.potName != "Multiplier") return
        if (this.layoutSpine?.state?.data?.skeletonData?.animations?.find(anim => anim.name == `winX${numberMultiplier}`)) {            
            this.audio.Track(this.resid.ScopedResourceName("ShowMultiplier")).Play(false)
            this.layoutSpine?.state?.setAnimation(0, `winX${numberMultiplier}`, false);
            //this.layoutSpine.state.addAnimation(0, `winX${numberMultiplier}`, false, 0);
        }
    }
}